export default __webpack_public_path__ + "static/media/join-avatar-4.a96aadf4.png";